export default {
    downtimeUrl: "https://cl.kodland.tech",
    startPage: {
      image: {
        url:  "/welcome/quiz_turkey_b2b_bil_kurs_pk.png",
        style: {
            height: "100%",
            "max-height": "100vh",
        },
      },
      imageMobile: {
        url: "/welcome/quiz_turkey_b2b_bil_kurs_mobile.png",
        style: {
          width: "100%",
        },
      },
      title: "Çocuğunuzun başarılı geleceği bir form uzaklıkta",
      subtitle:
        "Bire-bir, ücretsiz programlama deneme dersinizi hemen almak için formu 3 dakikada doldurun!",
      button: "Kaydolun",
    },
    stopPage: {
      image: "/welcome/quiz_stop_page.jpg",
      title: "Eğitim platformumuza güvendiğiniz için teşekkür ederiz! Maalesef tabletler veya telefonlar derslerimizi almak için uygun değil. Bir dahaki sefere sizi sınıflarımızda görmekten mutluluk duyarız!",
    },
    quizRotateBySteps: {
      1: {
        question: "Ücretsiz dersinizden kazanmak istediğiniz en önemli şeyler nelerdir?",
        answers: [
          "😌 Çocuğunuzla daha iyi bir iletişim/bağ",
          "🖥 Geleceğe yönelik yararlı beceriler",
          "👍 Samimi ve keyifli bir deneyim",
          "🎓 Çocuğunuzun motivasyonunda bir artış",
          "😎 Kullanıcı dostu öğrenme platformumuz hakkında bilgi",
        ],
      },
      2: {
        question: "Çocuğunuzun okulda en sevdiği ders hangisidir?",
        answers: [
          "🔬 Fen bilimleri",
          "🎨 Sanat ve tasarım",
          "💻 Bilgisayar bilimi",
          "📙 Tarih, Edebiyat",
          "📐 Matematik",
          "💬 Yabancı diller",
          "🤩 Tüm dersler",
          "🤔 Emin değilim",
        ],
      },
      3: {
        question: "Çalışabileceğiniz bir masaüstü/dizüstü bilgisayarınız var mı?",
        answers: [
          {
            answer: "💻 Evet",
            distribution_tag_question: [13,18],
          },
          {
            answer: "😐 Hayır",
            stopAnswer: true,
          },
        ],
      },
      4: {
        title: "Deneme dersi için hangi saatte uygunsunuz?",
        type: "timeslot",
        subtitle:
          "Özel dersinizi rezerve etmek için birkaç adım kaldı! Sizinle tanışmak için sabırsızlanıyoruz🥳",
        button: "Rezervasyon için tıklayın 🎁",
      },
      5: {
        question: "Çocuğunuzun herhangi bir bilgisayar becerisi var mı?",
        answers: [
          "😌 Evet, Microsoft Word/PowerPoint",
          "🖥 Evet, temel kodlama",
          "👍 Evet, oyun oynamayı sever (Roblox, Minecraft)",
          "🤔 Hayır",
        ],
      },
      6: {
        title: "Çocuğunuz kaç yaşında?",
        type: "age",
        subtitle: "Çocuğunuzun yaşına göre en eğlenceli kursu seçeceğiz. Lütfen çocuğunuzun doldurduğu yaşı seçin.",
        button: "İleri 🚀",
      },
      7: {
        title: "Çocuğunuzun adı nedir?",
        type: "child_name",
        subtitle: "Veriler korunmaktadır ve talebiniz üzerine silinecektir 🚨",
        button: "İleri 🚀",
      },
      8: {
        title: "E-postanızı girin",
        type: "mail",
        subtitle: "Endişelenmeyin, spam gönderilmeyecek😅",
        button: "İleri 🚀",
      },
      9: {
        title: "Telefon numaranızı girin",
        type: "phone",
        subtitle: "Önemli konularda sizinle iletişime geçmek için kullanacağız 📞",
        button: "Neredeyse bitti 🔥",
      },
      10: {
        question: "Çocuğunuzun bilgisayar başında geçirdiği zamanın daha verimli bir hâle gelmesini ister misiniz?",
        answers: [
          "😌 Evet",
          "🤔 Hayır",
        ],
      },
      11: {
        title: "İsminizi girin",
        type: "parent_name",
        subtitle: "Bizim adımız Kodland, sizinki ne?👋",
        button: "Son adım! 🎉",
      },
    },
  };
  
  